import { useRef } from 'react';
import { 
	Flex,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalFooter,
	ModalOverlay,
	Stack,
	Text
} from '@chakra-ui/react';
import { FormHandles } from '@unform/core';

import { formatPrice } from '../../../utils/format';
import formatInputMoeda from '../../../utils/formatInputMoeda';
import Input from '../../Inputs/Input';
import InputDate from '../../Inputs/InputDate';

import { FormView, Buttons } from './styles';

type BoletoData = {
	linha_dig: string;
	mora: number;
	multa: number;
	nosso_nro: string;
	registro: string;
	status: string;
	venc: string;
	vlr: number;
}
type ParcelaData = {
	amortizado: number;
	antecipado: boolean;
	baixado: boolean;
	boleto: BoletoData;
	data_baixa: string;
	desconto: number;
	id: string;
	juros: number;
	multa: number;
	outra_desp: number;
	pago: number;
	parcela: string;
	saldo_cred: number;
	saldo_deb: number;
	taxa_antecip: number;
	taxa_card: number;
	vencimento: string;
	vlr_cred: number;
	vlr_deb: number;
}
interface ModalParcelaEditParams {
	isOpen: boolean;
	onRequestClose: (close: boolean) => void;
	parcela: ParcelaData;
	parcelas: ParcelaData[];
	total: string;
}

const ModalParcelaEdit: React.FC<ModalParcelaEditParams> = ({
	isOpen,
	onRequestClose,
	parcela,
	parcelas,
	total,
}) => {
	const formEditParcelRef = useRef<FormHandles>(null);

	function handleSubmit() {
		let valor = formEditParcelRef.current?.getFieldValue('valor');
		valor = Number(valor.replace('R$', '').replace(' ', '').replace('.', '').replace(',', '.'));

		if ((parcela.vlr_cred !== 0 && valor !== parcela.vlr_cred) || (parcela.vlr_deb !== 0 && valor !== parcela.vlr_deb)) {
			let totall = total.replace('R$', '').replace(' ', '').replace('.', '').replace(',', '.');
			const numTotal = Number(totall);

			const auxTotal = numTotal - valor;

			const resto = Number((((auxTotal * 100) % (parcelas.length - 1)) / 100).toFixed(2));
			const div = Number((auxTotal / (parcelas.length -1)).toFixed(2));

			parcelas.map(parcel => {
				if (parcel.id !== parcela.id) {
					if (parcel.vlr_cred !== 0) {
						parcel.saldo_cred = div;
						parcel.vlr_cred = div;
					} else {
						parcel.saldo_deb = div;
						parcel.vlr_deb = div;
					}
				};

				return parcel;
			});

			parcelas[parcelas.length - 1].vlr_cred = parcelas[parcelas.length - 1].vlr_cred + resto;
		}

		if (parcela.vlr_cred !== 0) {
			parcela.saldo_cred = valor;
			parcela.vlr_cred = valor;
		} else {
			parcela.saldo_deb = valor;
			parcela.vlr_deb = valor;
		}

		parcela.vlr_cred = valor;
		parcela.vencimento = formEditParcelRef.current?.getFieldValue('vencimento');

		onRequestClose(false);
	}

	return (
		<Modal
			isCentered={true}
			size="lg"
			isOpen={isOpen}
			onClose={() => onRequestClose(false)}
		>
			<ModalOverlay />
			<ModalContent mt={0} mx={2}>
				<ModalCloseButton />

				<FormView ref={formEditParcelRef} initialData={parcela} onSubmit={() => { }}>
					<ModalBody>
						<Text
							fontSize={20}
							fontWeight={500}
							mt={4}
						>
							Parcela {parcela.parcela}
						</Text>

						<Flex flexDir="column" w="100%">
							<Stack direction="column" spacing={0} w="100%">
								{/* VALOR */}
								< div className="input">
									<p>Valor</p>
									<Input
										name="valor"
										type="text"
										placeholder="Valor do título"
										defaultValue={parcela.vlr_cred !== 0 
											? formatPrice(parcela.vlr_cred) 
											: formatPrice(parcela.vlr_deb)
										}
										onChange={() => formatInputMoeda('valor', formEditParcelRef)}
										containerStyle={{ padding: '6px 10px' }}
									/>
								</div>

								{/* VENCIMENTO */}
								<div className="input">
									<p>Vencimento</p>
									<InputDate
										name="vencimento"
										// defaultValue={parcela.data}
										placeholder="data do título"
										containerStyle={{ padding: '5px 10px' }}
									/>
								</div>
							</Stack>
						</Flex>
						
					</ModalBody>

					<ModalFooter pt={["0", "2"]}>
						<Buttons>
							<button
								type="button"
								className="button-cancel"
								onClick={() => onRequestClose(false)}
							>
								Cancelar
							</button>

							<button
								type="submit"
								className="button-save"
								onClick={handleSubmit}
							>
								Editar
							</button>
						</Buttons>
					</ModalFooter>
				</FormView>
			</ModalContent>
		</Modal>
	)
}

export default ModalParcelaEdit;